import MuiCssBaseline, { CssBaselineProps } from '@mui/material/CssBaseline';

export interface ICssBaselineProps extends CssBaselineProps {}

const CssBaseline = (props: ICssBaselineProps): JSX.Element => {
  return <MuiCssBaseline {...props} />;
};

export default CssBaseline;
